<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Customers") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'customer.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      /> -->
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1 mt-1"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></advanced-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";
import axios from "axios";
import { persistentTableOptions } from "../../../plugins/mixins";

var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-customer-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],
      filters: []
    };
  },

  mounted() {
    this.getData();
  },

  computed: {
    headers() {
      if (this.$auth.check("order.editall")) {
        return [
          {
            text: this.$t("name"),
            align: "left",
            value: "name"
          },
          {
            text: this.$t("customer_number"),
            align: "left",
            value: "number"
          },
          {
            text: this.$t("city"),
            align: "left",
            value: "city"
          },
          {
            text: this.$t("Member"),
            align: "left",
            value: "member_name",
            sortable: false
          },
          { text: "", value: "action", sortable: false }
        ];
      } else {
        return [
          {
            text: this.$t("name"),
            align: "left",
            value: "name"
          },
          {
            text: this.$t("customer_number"),
            align: "left",
            value: "number"
          },
          {
            text: this.$t("city"),
            align: "left",
            value: "city"
          },
          { text: "", value: "action", sortable: false }
        ];
      }
    },
    filterCols() {
      if (this.$auth.check("order.editall")) {
        return [
          {
            title: this.$t("customer"),
            name: "name",
            type: "text"
          },
          {
            title: this.$t("customer_number"),
            name: "number",
            type: "text"
          },
          {
            title: this.$t("city"),
            name: "city",
            type: "text"
          },
          {
            title: this.$t("Company"),
            name: "company.name",
            type: "text"
          }
        ];
      } else {
        return [
          {
            title: this.$t("customer"),
            name: "name",
            type: "text"
          },
          {
            title: this.$t("customer_number"),
            name: "number",
            type: "text"
          },
          {
            title: this.$t("city"),
            name: "city",
            type: "text"
          }
        ];
      }
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      if (cancel != undefined) {
        cancel();
      }
      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          filters: this.filters
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Customer?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "customer.edit", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
